// Shared kb-experiment loader. A pure-CSS spinner — deliberately NOT Lottie:
// this is the boot Suspense fallback (App.js) and the seller/PLP loading state,
// so it sits on the critical path. lottie-react + its JSON cost ~50KB gzip just
// to render a spinner while everything else loads. `full` centres it as a
// page-loading state. Visual styles live in theme.css (.kb-loader/.kb-spin).
export default function Loader({ size = 48, full = false }) {
	return (
		<div className={full ? 'kb-loader kb-loader-full' : 'kb-loader'}>
			<span
				className="kb-spin"
				style={{ width: size, height: size }}
				role="status"
				aria-label="Loading"
			/>
		</div>
	);
}
